import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from '@app/core/hooks/redux-hooks';
import { InstrumentOption } from './useInstrumentOptions';
import { formConfigBase } from '@app/shared/constants/form-config-base';
import { setIrrHurdleSelectedInstrument } from '@app/core/store/ui-values-slice';
import { FormData } from '../IRRHurdleTableHeader';
import { useFocusMode } from '@app/shared/hooks/focus-mode';
import { SponsorIrrAndHurdleTab } from '@app/shared/models/contracts/enums/shared-enums';
import { IrrHurdleFocusSelections } from '@app/shared/hooks/focus-mode/focus-mode-types';

export const useInstrumentForm = (instrumentOptions: InstrumentOption[]) => {
  const dispatch = useAppDispatch();

  const storedSelectedInstrument = useAppSelector(
    (state) =>
      state.uiValues.userSelections.sponsorIrrAndHurdle.irrHurdleCalculations.selectedInstrument
  );

  const { isActive, selections } = useFocusMode();

  const irrSelections =
    selections?.type === SponsorIrrAndHurdleTab.IRRHurdleCalculations
      ? (selections as IrrHurdleFocusSelections)
      : undefined;

  const navigatedSelectedHurdle = isActive ? irrSelections?.hurdle : undefined;
  const navigatedSelectedInstrument = isActive ? irrSelections?.instrument : undefined;
  const navigatedSelectedYear = isActive ? irrSelections?.year : undefined;

  const isStoredSelectedInstrumentValid =
    instrumentOptions.length === 0
      ? Boolean(storedSelectedInstrument)
      : instrumentOptions.some((option) => option.value === storedSelectedInstrument);

  const formMethods = useForm<FormData>({
    ...formConfigBase,
    defaultValues: {
      selectedInstrument: navigatedSelectedInstrument
        ? navigatedSelectedInstrument
        : isStoredSelectedInstrumentValid
        ? storedSelectedInstrument
        : instrumentOptions[0]?.value || '',
    },
  });

  const selectedInstrument = formMethods.watch('selectedInstrument');

  useEffect(() => {
    dispatch(setIrrHurdleSelectedInstrument(selectedInstrument));
  }, [dispatch, selectedInstrument]);

  return {
    formMethods,
    selectedInstrument,
    navigatedSelectedHurdle,
    navigatedSelectedYear,
  };
};
